'use strict'

angular.module('rmGroups')
    .factory('Group', require('./group'))
